<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">系统设置</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">线索加密</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-list">
            <a-divider orientation="left">
            线索号码加密方式
            </a-divider>

            <div class="fpstyle" >
                <a-radio-group v-model="detail.passtype" size="large" @change="onChange" >

                    <a-radio :value="1">
                    全显不加密
                    </a-radio>

                    <p>加密方式：对线索数据的号码不进行加密。例如：13333333333 => 【13333333333】</p>
                    

                    <a-radio :value="2" style="margin-top:30px">
                    前三后四式加密
                    </a-radio>

                    <p>加密方式：将所有线索数据的号码进行前3后4加密。例如：13333333333 => 【133****3333】</p>

                    <a-radio :value="3"  style="margin-top:30px">
                    MD5加密
                    </a-radio>

                    <p>加密方式：将所有线索数据的号码进行MD5加密。例如：13333333333 => 【34347C343003E57232A5D21F14FE399E】</p>
                </a-radio-group>

                <a-button type="primary" @click="tofptype" style="margin-top:20px;display:block">
                    确定
                </a-button>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            type:"",
            detail:""
        }
    },
    mounted(){
        this.getdetail()
    },
    methods:{
        onChange(e) {
            this.type=e.target.value
        },
        tofptype(){
            this.$axios.post('/api/system/systemset',{
                passtype:this.type
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    localStorage.setItem('pwdtype', this.type);
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        },

        getdetail(){
            this.$axios.post('/api/system/systemsetpage',{

            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.detail=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/components/system/pwdstyle.vue